'use client';

import { Typography } from '@mui/material';
import styled from 'styled-components';

const Headline = styled.div`
  padding-bottom: 40px;
  padding-top: 20px;

  ${({ theme }) => theme.breakpoints.down('md')} {
    padding-bottom: 2rem;
    padding-top: 2rem;
  }
`;

export default function DownloadHeader({ title }) {
  return (
    <Headline>
      <Typography variant="h1">{title}</Typography>
    </Headline>
  );
}
